import { render, staticRenderFns } from "./Company_establishments_edition.vue?vue&type=template&id=3760fd4a&scoped=true&lang=pug&"
import script from "./Company_establishments_edition.vue?vue&type=script&lang=coffee&"
export * from "./Company_establishments_edition.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3760fd4a",
  null
  
)

export default component.exports